// extracted by mini-css-extract-plugin
export default {"container":"ProgressContent_container__V+n2k","image":"ProgressContent_image__5lO8v","wrapper":"ProgressContent_wrapper__Ppdfv","value":"ProgressContent_value__nLXWK"};